<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="'tags'"
           nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzLabel]="op" [nzValue]="op"></nz-option>
</nz-select>
